export default function aiUseCaseV2({ AiServiceV2 }) {
  const translateContent = (data) => AiServiceV2.translateContent(data);

  return { translateContent };
}
